import { createFileRoute } from '@tanstack/react-router';
import { TracksList } from '@/components/tracks/TracksList.tsx';

export const Route = createFileRoute('/_app/tracks/')({
  staticData: { orgScope: 'required' },
  component: TracksList,
});
